import styled from 'styled-components';

export const StyledSpan = styled.span `
    color: red;
`